
export function addApplicants(){

 	coapplicants = coapplicants || coapplicants.push(1);
	// Array starts with 0 but the id start with 0 so push a dummy value
	var div = document.createElement('div');
  	var id = getID();
  	div.setAttribute("id","coapplicantsDiv_"+id);
  	div.setAttribute("class","user_details user_details_button clearfix");
  	
    var divtag = `<h5>Co-applicant ${id+1} <span onclick="HomeLoanCalculator.removeCoApplicants(${id})">- Remove Co-applicant ${id+1}</span></h5>
	                <div class="clearfix"></div>
	                <div class="field_cal">
	                  <label>First Name </label>
	                  <div class="field">
	                    <input type="text" id="coFirstName_${id}" placeholder="Enter First Name" />
	                    <div class="error hide" id="coFirstName_error_${id}">Please enter valid name</div>
	                  </div>
	                </div>
	                <div class="field_cal">
	                  <label>Last Name </label>
	                  <div class="field">
	                    <input type="text" id="coLastName_${id}" placeholder="Enter Last Name" />
	                  </div>
	                </div>
	                <div class="field_cal">
	                  <label>Residence Status</label>
	                  <div class="field dropdown" dropdown>
	                    <a href="javascript:(void);" class="drop_box" data-toggle="dropdown" id="select_residence_${id}">
	                      Residence Status
	                    </a>
	                    <div class="error hide" id="hiddenCoResidenceStatus_error_${id}">Select Residence</div>
                  		<input type="hidden" id="hiddenCoResidenceStatus_${id}"/>
	                    <i class="icon-arrow"></i>
	                    <ul class="dropdown-menu"  id="coResidenceStatus_${id}">
	                      <li data-cid="${id}" data-value="RES">Indian</li>
                    	  <li data-cid="${id}" data-value="NRI">NRI</li>
	                    </ul>
	                  </div>
	                </div>
	                <div class="field_cal opacity_otp" id="coCountry_${id}">
	                  <label>Current Country</label>
	                  <div class="field dropdown" dropdown>
	                  	<input type="text" id="countrySearch_${id}" onkeyup="HomeLoanCalculator.selectOption(event,this.id)" placeholder="Select your country" data-toggle="dropdown" />
	                    <input type="hidden" id="hiddenCountry_${id}"/>
                  		<div class="error hide" id="hiddenCountry_error_${id}">Select Current Country</div>
	                    <i class="icon-arrow"></i>
	                    <ul class="dropdown-menu" id="countrySearch_${id}Ul">
	                    </ul>
	                  </div>
	                </div>
	                <div class="field_cal opacity_otp" id="coState_${id}">
	                  <label>Current State</label>
	                  <div class="field dropdown" dropdown>
	                    <input type="text" id="stateSearch_${id}" onkeyup="HomeLoanCalculator.selectOption(event,this.id)" placeholder="Select your state" data-toggle="dropdown" />
	                    <input type="hidden" id="hiddenState_${id}"/>
                  		<div class="error hide" id="hiddenState_error_${id}">Select Current State</div>
	                    <i class="icon-arrow"></i>
	                    <ul class="dropdown-menu" id="stateSearch_${id}Ul">
	                    </ul>
	                  </div>
	                </div>
	                <div class="field_cal opacity_otp" id="coCity_${id}">
	                  <label>Current City</label>
	                  <div class="field dropdown" dropdown>
	                    <input type="text" id="coCitySearch_${id}" onkeyup="HomeLoanCalculator.selectOption(event,this.id)" placeholder="Select your City" data-toggle="dropdown" />
	                    <input type="hidden" id="hiddenCoCityId_${id}"/>
                  		<div class="error hide" id="hiddenCoCityId_error_${id}">Select your city</div>
	                    <i class="icon-arrow"></i>
	                    <ul class="dropdown-menu" id="coCitySearch_${id}Ul">
	                    </ul>
	                  </div>
	                </div>
	                <div class="field_cal">
	                  <label>Gender</label>
	                  <div class="field radio">
	                    <div class="input-div">
	                      <input type="radio" id="coMale_${id}" name="${id+4}"  checked/>
	                      <label for="coMale_${id}">Male</label>
	                    </div>
	                    <div class="input-div">
	                      <input type="radio" id="coFemale_${id}" name="${id+4}" />
	                      <label for="coFemale_${id}">Female</label>
	                    </div>
	                  </div>
	                </div>
	                <div class="field_cal">
	                  <label>Age </label>
	                  <div class="field">
	                    <input type="text" id="coAge_${id}" placeholder="Enter Age" onkeyup="HomeLoanCalculator.isNemericCoValue('coAge_',${id})"/>
	                    <div class="error hide" id="coAge_error_${id}">Please enter valid age</div>
	                  </div>
	                </div>
	                <div class="field_cal">
	                  <label>Occupation</label>
	                  <div class="field dropdown" dropdown>
	                    <a href="javascript:(void);" class="drop_box" data-toggle="dropdown" id="select_coOccupation_${id}">
	                      Select your Occupation
	                    </a>
	                    <div class="error hide" id="hiddenCoOccupation_error_${id}">Select Occupation</div>
                  		<input type="hidden" id="hiddenCoOccupation_${id}"/>
	                    <i class="icon-arrow"></i>
	                    <ul class="dropdown-menu" id="coOccupation_${id}">
	                      <li data-cid="${id}" data-value="E">Employed</li>
	                      <li data-cid="${id}" data-value="H">Housewife</li>
	                      <li data-cid="${id}" data-value="O">Retired</li>
	                      <li data-cid="${id}" data-value="S">Self Employed</li>
	                      <li data-cid="${id}" data-value="D">Student</li>
	                    </ul>
	                  </div>
	                </div>
	                <div class="field_cal opacity_otp" id="coMonthlyIncome_${id}">
	                  <label>Gross Monthly Income</label>
	                  <div class="field">
	                    <i class="rupee">&#8377;</i>
	                    <input type="text" id="co_gross_monthly_income_${id}" placeholder="Enter Gross Monthly Income" onkeyup="HomeLoanCalculator.convertCoPrice('co_gross_monthly_income_',${id})"/>
	                    <div class="error hide" id="co_gross_monthly_income_error_${id}">Please enter valid retired age</div>
	                    <small id="co_gross_monthly_income_${id}_price"></small>
	                  </div>
	                </div>
	                <div class="field_cal opacity_otp" id="co_retired_age_${id}">
	                  <label>Retiring Age </label>
	                  <div class="field">
	                    <input type="text" id="coRetiredAge_${id}" placeholder="Retiring Age " onkeyup="HomeLoanCalculator.isNemericCoValue('coRetiredAge_',${id})"/>
	                    <div class="error hide" id="coRetiredAge_error_${id}">Please enter valid retired age</div>
	                  </div>
	                </div>
	                <div class="field_cal opacity_otp" id="co_other_emi_${id}">
	                  <label>Other EMI </label>
	                  <div class="field">
	                    <input type="text" placeholder="Other EMI " id="otherEmi_${id}" onkeyup="HomeLoanCalculator.convertCoPrice('otherEmi_',${id})"/>
	                    <div class="error hide" id="otherEmi_error_${id}">Please enter valid retired age</div>
	                    <small id="otherEmi_${id}_price"></small>
	                  </div>
	                </div>`;

	div.innerHTML = divtag;
	document.getElementById('add_co_applicants').appendChild(div);
	return id;

}

function getID(){
   var emptyIndex = coapplicants.indexOf(-1);
   if (emptyIndex != -1){
     coapplicants[emptyIndex] = emptyIndex
     
     return emptyIndex
   } else {
	   emptyIndex = coapplicants.length
	   coapplicants.push(emptyIndex)
	   return emptyIndex
   }
}

export function removeApplicants(id){
	// use the id arugment to get the div element using unique id set in addkid
	try{
		var element = document.getElementById("coapplicantsDiv_"+id)
		element.parentNode.removeChild(element);
		    coapplicants[id] = -1;
	    //id number is = index of the array so we set to -1 to indicate its empty
	}catch(err){
	    alert("id: coapplicantsDiv_"+id)
	    alert(err)
	    
	}

}

export function validateCoApplicants(coApplicants){
	
	let isApplicantValid = false;
	for (var i = 0; i < coApplicants.length; i++){
		var divId = coApplicants[i].id;
		var divIdSplit = divId.split('_');
		var coid = divIdSplit[1];
		isApplicantValid = validateCoApplicantsForm(coid);
	}
	return isApplicantValid;
	
}

function validateCoApplicantsForm(coid){
	var coapplicants = {};
	let isCoApplicantValid = true;
	let username = document.getElementById('coFirstName_'+coid).value;
	let regex = /^[A-Za-z0-9 ]+$/i;
	if(username.match(regex) && username !='') {
		HomeLoanCalculator.hideError('coFirstName_error_'+coid);
		coapplicants.fullName = username + document.getElementById('coLastName_'+coid).value;;
	} else {
		let msg = "Please enter valid name";
		HomeLoanCalculator.showError('coFirstName_error_'+coid, msg);
		isCoApplicantValid = false;
	}
	
	let coAge = document.getElementById('coAge_'+coid).value;
	let coAgeregex = /^[0-9 ]+$/i;
	if(coAge.match(coAgeregex) && coAge !='') {
		HomeLoanCalculator.hideError('coAge_error_'+coid);
		coapplicants.coAge = coAge;
	} else {
		let msg = "Please enter valid age";
		HomeLoanCalculator.showError('coAge_error_'+coid, msg);
		isCoApplicantValid = false;
	}
	
	let hiddenCoResidenceStatus = document.getElementById('hiddenCoResidenceStatus_'+coid).value;
	let hiddenCoResidenceregex = /^[0-9 ]+$/i;
	if(hiddenCoResidenceStatus !='') {
		HomeLoanCalculator.hideError('hiddenCoResidenceStatus_error_'+coid);
		coapplicants.residenceStatus = hiddenCoResidenceStatus;
	} else {
		let msg = "Please Select Residence";
		HomeLoanCalculator.showError('hiddenCoResidenceStatus_error_'+coid, msg);
		isCoApplicantValid = false;
	}
	
	let hiddenCoOccupation = document.getElementById('hiddenCoOccupation_'+coid).value;
	if(hiddenCoOccupation !='') {
		HomeLoanCalculator.hideError('hiddenCoOccupation_error_'+coid);
		coapplicants.userOccupation = hiddenCoOccupation;
	} else {
		let msg = "Please Select Occupation";
		HomeLoanCalculator.showError('hiddenCoOccupation_error_'+coid, msg);
		isCoApplicantValid = false;
	}
	
	if(hiddenCoOccupation == 'E'){
		let coRetiredAge = document.getElementById('coRetiredAge_'+coid).value;
		let coRetiredAgeregex = /^[0-9 ]+$/i;
		if(coRetiredAge.match(coRetiredAgeregex) && coRetiredAge !='') {
			HomeLoanCalculator.hideError('coRetiredAge_error_'+coid);
			coapplicants.coRetiredAge = coRetiredAge;
		} else {
			let msg = "Please enter valid retired age";
			HomeLoanCalculator.showError('coRetiredAge_error_'+coid, msg);
			isCoApplicantValid = false;
		}

		let co_gross_monthly_income = document.getElementById('co_gross_monthly_income_'+coid).value;
		co_gross_monthly_income = co_gross_monthly_income.replace(/,/g, '');
		let incomeregex = /^[0-9 ]+$/i;
		if(co_gross_monthly_income.match(incomeregex) && co_gross_monthly_income !='') {
			HomeLoanCalculator.hideError('co_gross_monthly_income_error_'+coid);
			coapplicants.monthlyIncome = co_gross_monthly_income;
		} else {
			let msg = "Please enter gross monthly income";
			HomeLoanCalculator.showError('co_gross_monthly_income_error_'+coid, msg);
			isCoApplicantValid = false;
		}
	}

	if(hiddenCoResidenceStatus == 'NRI'){
		let hiddenCountry = document.getElementById('hiddenCountry_'+coid).value;
		if(hiddenCountry !='') {
			HomeLoanCalculator.hideError('hiddenCountry_error_'+coid);
			coapplicants.currentCountry = hiddenCountry;
		} else {
			let msg = "Please Select Country";
			HomeLoanCalculator.showError('hiddenCountry_error_'+coid, msg);
			isCoApplicantValid = false;
		}
	}else if(hiddenCoResidenceStatus == 'RES'){
		let hiddenState = document.getElementById('hiddenState_'+coid).value;
		if(hiddenState !='') {
			HomeLoanCalculator.hideError('hiddenState_error_'+coid);
			coapplicants.currentState = hiddenState;
		} else {
			let msg = "Please Select State";
			HomeLoanCalculator.showError('hiddenState_error_'+coid, msg);
			isCoApplicantValid = false;
		}

		let hiddenCoCityId = document.getElementById('hiddenCoCityId_'+coid).value;
		if(hiddenCoCityId !='') {
			HomeLoanCalculator.hideError('hiddenCoCityId_error_'+coid);
			coapplicants.currentCityId = hiddenCoCityId;
		} else {
			let msg = "Please Select City";
			HomeLoanCalculator.showError('hiddenCoCityId_error_'+coid, msg);
			isCoApplicantValid = false;
		}
	}
	
	if(document.getElementById('coMale_'+coid).checked == true){
		coapplicants.gender = 'M';
	}else if(document.getElementById('coFemale_'+coid).checked == true){
		coapplicants.gender = 'F';
	}
	coapplicants.otherEMI = (document.getElementById('otherEmi_'+coid).value).replace(/,/g, '');

	homeloancalc.coapplicants.push(coapplicants);
	return isCoApplicantValid;
}













